import debounce from 'lodash.debounce';
import React, { useState } from 'react';
import { AiOutlinePlus } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../components/shared/buttons/Button';
import ContainerHeader from '../../components/shared/container/ContainerHeader';
import Search from '../../components/shared/search/Search';
import { getModelsActions, setModelsSearchAction } from '../../redux/actions/modelsActions';
import CreateModelModal from './modals/CreateModelModal';

const ModelsHeader = ({ readOnly }) => {
  const dispatch = useDispatch();
  const brandId = useSelector((state) => state.models.brand?.id);
  const search = useSelector((state) => state.models?.search);
  const [showCreateModelModal, setShowCreateModelModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const debounced = debounce((args) => {
    dispatch(setModelsSearchAction(args));
  }, 500);

  const handleSearchChange = (newSearchValue) => {
    debounced(newSearchValue);
  };

  const handleModelModalSubmit = async () => {
    setShowCreateModelModal(false);
    setLoading(true);
    await dispatch(getModelsActions(search, brandId));
    setLoading(false);
  };

  return (
    <ContainerHeader>
      {showCreateModelModal && (
        <CreateModelModal
          onModalSubmit={() => handleModelModalSubmit()}
          onModalClose={() => setShowCreateModelModal(false)}
        />
      )}
      <Search value={search.search} onChangeAction={handleSearchChange} />
      {!readOnly && (
        <Button variant={'primary'} disabled={loading} onClick={() => setShowCreateModelModal(true)}>
          <AiOutlinePlus />
          Додати
        </Button>
      )}
    </ContainerHeader>
  );
};

export default ModelsHeader;
